import Holiday from './Holiday';

export default Holiday;
